"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var fromPromise_1 = require("rxjs/observable/fromPromise");
var DeFormModuleLoadingService = /** @class */ (function (_super) {
    __extends(DeFormModuleLoadingService, _super);
    function DeFormModuleLoadingService(additionalPaths, additionalSummaryPaths) {
        if (additionalPaths === void 0) { additionalPaths = {}; }
        if (additionalSummaryPaths === void 0) { additionalSummaryPaths = {}; }
        var _this = this;
        var paths = Object.assign({
            'node_modules/@synisys/idm-ng-controls/bundles/idm-ng-controls.umd.min#ControlsModule': function () {
                return fromPromise_1.fromPromise(Promise.resolve().then(function () { return require('@synisys/idm-ng-controls'); })).map(function (t) { return t.ControlsModule; });
            },
            'node_modules/@synisys/idm-dynamic-forms-controls/app/dynamic-controls.module#DynamicFormControlsModule': function () {
                return fromPromise_1.fromPromise(Promise.resolve().then(function () { return require('@synisys/idm-dynamic-forms-controls'); })).map(function (t) { return t.DynamicFormControlsModule; });
            },
            'node_modules/@synisys/idm-document-service-client-js/app/document-controls.module#DocumentControlsModule': function () {
                return fromPromise_1.fromPromise(Promise.resolve().then(function () { return require('@synisys/idm-document-service-client-js'); })).map(function (t) { return t.DocumentControlsModule; });
            },
            'node_modules/@synisys/idm-entity-search-client-js/app/entity-search.module#EntitySearchModule': function () {
                return fromPromise_1.fromPromise(Promise.resolve().then(function () { return require('@synisys/idm-entity-search-client-js'); })).map(function (t) { return t.EntitySearchModule; });
            },
        }, additionalPaths);
        var summaries = Object.assign({}, additionalSummaryPaths);
        _this = _super.call(this, paths, summaries) || this;
        return _this;
    }
    DeFormModuleLoadingService_1 = DeFormModuleLoadingService;
    var DeFormModuleLoadingService_1;
    DeFormModuleLoadingService.additionalPathsToken = new core_1.InjectionToken('additional paths form forms to be included if available');
    DeFormModuleLoadingService.additionalSummaryPathsToken = new core_1.InjectionToken('additional paths form forms to be included if available');
    DeFormModuleLoadingService = DeFormModuleLoadingService_1 = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()), __param(0, core_1.Inject(DeFormModuleLoadingService_1.additionalPathsToken)),
        __param(1, core_1.Optional()),
        __param(1, core_1.Inject(DeFormModuleLoadingService_1.additionalSummaryPathsToken)),
        __metadata("design:paramtypes", [Object, Object])
    ], DeFormModuleLoadingService);
    return DeFormModuleLoadingService;
}(idm_dynamic_layout_interpreter_1.ModuleLoadingService));
exports.DeFormModuleLoadingService = DeFormModuleLoadingService;
//# sourceMappingURL=de-form-module-loading.service.js.map